import styled from 'styled-components'

export const TableContainer = styled.div`
  max-height: 457px;
`
